import styled from 'styled-components';
import { palette } from 'styled-theme';

export const FooterContainer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px;
  background-color: #fbf8ff;
  opacity: 0.8;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const FooterLink = styled.a`
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;

  text-decoration: none;
  cursor: pointer;

  color: blue;
  text-decoration: underline;
  text-underline-offset: 1px;
`;
export const FooterText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;
